import { SESSION_STORAGE_KEYS, SUBMODULE_TYPE } from '@constants/constants';
import { SessionStorage } from '@utils/storage';
import { DEEP_LINK_CONFIG } from '../constants';

/**
 * With a submodule: removes only that submodule's params, e.g. when the user has no access to it.
 * Without one: removes the redirect and every submodule's params, e.g. on logout or before storing a
 * new deep link (only one deep link is active at a time, so older params would never be consumed).
 */
const clearDeepLinkStorage = (submodule?: SUBMODULE_TYPE) => {
  if (!submodule) SessionStorage.remove(SESSION_STORAGE_KEYS.SUBMODULE_TO_REDIRECT);

  const configs = submodule ? [DEEP_LINK_CONFIG[submodule]] : Object.values(DEEP_LINK_CONFIG);
  configs.forEach((config) =>
    config?.params.forEach(({ storageKey }) => SessionStorage.remove(storageKey)),
  );
};

export default clearDeepLinkStorage;
